import { Component, OnInit, Inject, OnDestroy, EventEmitter, ViewEncapsulation } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { CoreService } from 'src/app/core/helpers/core.service';
import { AuthService } from 'src/app/core/helpers/auth.service';
import { ToastrService } from 'ngx-toastr';
import { WebcamImage, WebcamInitError, WebcamUtil } from 'ngx-webcam';
import { GaService } from 'src/app/core/helpers/ga.service';


@Component({
  selector: 'loyaltic-capture-image',
  templateUrl: './capture-image.component.html',
  styleUrls: ['./capture-image.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CaptureImageComponent implements OnInit {

  public pictureTaken = new EventEmitter<WebcamImage>();
  public showWebcam = true;
  public allowCameraSwitch = true;
  public camPermission = true;
  facingMode: string = 'user';  //Set front camera
  public multipleWebcamsAvailable = false;
  public deviceId: string;
  public webcamImage: WebcamImage = null;
  gameUrl: any;
  uploadImage: any;
  imageName: any;
  imageSrc: any;


  private trigger: Subject<void> = new Subject<void>();
  // switch to next / previous / specific webcam; true/false: forward/backwards, string: deviceId
  private nextWebcam: Subject<boolean|string> = new Subject<boolean|string>();


  constructor(private coreService: CoreService, private authService: AuthService,
    private toast: ToastrService,public gaService: GaService,) { }

  ngOnInit() {
    WebcamUtil.getAvailableVideoInputs()
    .then((mediaDevices: MediaDeviceInfo[]) => {
      this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
    });
    this.gameUrl = localStorage.getItem('gameurl');
  }

  public handleInitError(error: WebcamInitError): void {
    if (error.mediaStreamError && error.mediaStreamError.name === 'NotAllowedError') {
      this.camPermission = false;
    }
  }

  public triggerSnapshot(): void {
    this.trigger.next();
  }

  public toggleWebcam(): void {
    this.showWebcam = !this.showWebcam;
  }

  public get videoOptions(): MediaTrackConstraints {
    const result: MediaTrackConstraints = {};
    if (this.facingMode && this.facingMode !== '') {
        result.facingMode = { ideal: this.facingMode };
    }
    return result;
}

  public playGame() {
    window.open(this.gameUrl, '_blank');
  }

  public showNextWebcam(directionOrDeviceId: boolean|string): void {
    this.nextWebcam.next(directionOrDeviceId);
    this.webcamImage =null;
    this.imageSrc = null;
  }

  public handleImage(webcamImage: WebcamImage): void {
    console.info('received webcam image', webcamImage);
    this.pictureTaken.emit(webcamImage);
    this.webcamImage = webcamImage;
  }

  public cameraWasSwitched(deviceId: string): void {
    console.log('active device: ' + deviceId);
    this.deviceId = deviceId;
  }

  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }

  public get nextWebcamObservable(): Observable<boolean|string> {
    return this.nextWebcam.asObservable();
  }

  public uploadAvatar() {
    if (this.webcamImage !== null) {
      const arr = this.webcamImage.imageAsDataUrl.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      const file: File = new File([u8arr], this.authService.getUserId(), { type: 'image/jpeg' })
      const formData = new FormData();
      formData.append('File', file);
      this.coreService.captureImage(formData, this.authService.getUserId()).then((imageResponse: any) => {
        //this.gaService.emitEvent('play', 'captureImage');
        window.open(this.gameUrl, '_self');
      });
    } else {
      window.open(this.gameUrl, '_self');
    }
  }

  goToGame() {
    window.open(this.gameUrl, '_self');
  }

  onImageSelect(event) {
    this.uploadImage = event.target.files[0];
    this.imageName = this.uploadImage.name;
    if (event.target.files && event.target.files[0]) {
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.onload = (e: any) => {
        const img = document.createElement('img');
        img.src = e.target.result;
        this.imageSrc = e.target.result;
      };
    }
  }

}
